import {connect} from 'react-redux';
import Preferences from './Preferences';
import Constants from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState) => {
   return {
      themeName: state.themeName || Constants.themeName.default,
      commentNotificationSettings: state.commentNotificationSettings,
      replyNotificationSettings: state.replyNotificationSettings,
      currentUserId: state.currentUserId
   };
};

export default connect(mapStateToProps)(Preferences);
